import { DesignData } from 'editor/src/store/design/types';
import { AutoFillData } from 'editor/src/store/editor/operation/autoFillOperation';
import getLayoutSchemasBySlotNumbers from 'editor/src/store/editor/selector/getLayoutSchemasBySlotNumbers';
import { GalleryImage } from 'editor/src/store/gallery/types';

import { RootState } from 'editor/src/store';
import isImagePlaceholder from 'editor/src/util/design/isImagePlaceholder';

import findEmptySpreadIndexes from './findEmptySpreadIndexes';
import findNotUsedImages from './findNotUsedImages';

const applyAutoFill = (designData: DesignData, galleryImages: GalleryImage[], state: RootState) => {
  let imageIndex = 0;
  const autoFillData: AutoFillData[] = [];
  const IMAGES_TO_BE_PLACED = 1;

  const emptySpreadIndexes = findEmptySpreadIndexes(designData);
  const layoutSchemas = getLayoutSchemasBySlotNumbers(state, [IMAGES_TO_BE_PLACED], true);
  const notUsedImages = findNotUsedImages(galleryImages, designData);
  designData.spreads.forEach((spread, index) => {
    if (emptySpreadIndexes?.some((spreadIndex) => spreadIndex === index)) {
      spread.pages.forEach((page, pageIndex) => {
        let imagesToBePlaced = IMAGES_TO_BE_PLACED;
        let replacePlaceholderElements = false;
        // if spread has empty image placeholders we should replace them with elements
        if (page.groups.media) {
          const emptyPlaceholdersCount = page.groups.media.filter(isImagePlaceholder).length;
          if (emptyPlaceholdersCount) {
            replacePlaceholderElements = true;
            imagesToBePlaced = emptyPlaceholdersCount;
          }
        }

        if (page.groups.content) {
          autoFillData.push({
            pageIndex,
            spreadIndex: index,
            layoutSchema: layoutSchemas[1],
            images: notUsedImages.slice(imageIndex, imageIndex + imagesToBePlaced),
            replacePlaceholderElements,
          });
          imageIndex += imagesToBePlaced;
        }
      });
    }
  });
  return autoFillData;
};

export default applyAutoFill;
